<div class="search-filter-toolbar">
  <!-- Optional heading row above the search, e.g. a page title / group picker.
       Collapses to nothing when a host doesn't project into it. -->
  <div class="toolbar-heading">
    <ng-content select="[toolbarHeading]"></ng-content>
  </div>
  <!-- The pager sits to the RIGHT of the toolbar on a wide screen, so the toolbar keeps clear
       of it. On a narrow one the two stack and there is nothing beside the toolbar to avoid —
       reserving that width there just left the search field short of the screen. A class, not
       an inline width, because only CSS can tell the two cases apart. -->
  <div class="toolbar-content" [class.has-pagination]="hasPagination">
    <!-- Search Section -->
    <div class="search-section" *ngIf="config.showSearch">
      <!-- The 10% is room for the expand chevron beside it. When that is not being shown there
           is nothing to make room for, and the field was simply 10% short. -->
      <div class="search-input-wrapper" [class.has-search-action]="hasSearchAction"
        [ngStyle]="{ 'width': (isMobileDevice && showMobileExpand) ? '90%' : '100%' }">
        <i class="search-icon fa fa-search"></i>
        <input type="text" [placeholder]="config.searchPlaceholder" class="search-input" [value]="searchText"
          (input)="onSearchInput($event)" [title]="config.searchPlaceholder" />
        <button *ngIf="searchText" class="clear-search-btn" (click)="clearSearch()" title="Clear search">
          <i class="fa fa-times"></i>
        </button>
        <!-- An applied filter reads as part of the search: it sits inside the
             field, beside the control that opened it. -->
        <ng-content select="[searchFilterChip]"></ng-content>
        <!-- Action docked at the right end of the field, e.g. a filter funnel. -->
        <ng-content select="[searchAction]"></ng-content>
      </div>
      <div *ngIf="isMobileDevice && showMobileExpand" (click)="toggleExpandFilters()">
        <img src="../../../assets/img/invoiceForm/dropdownarrow.svg" *ngIf="!isFilterExpanded" />
        <svg _ngcontent-til-c235="" width="12" height="8" *ngIf="isFilterExpanded" viewBox="0 0 14 8" fill="none"
          xmlns="http://www.w3.org/2000/svg" style="transform: rotate(180deg);">
          <path _ngcontent-til-c235="" d="M0 1.14343L7 8L14 1.14343L12.8335 0L7 5.71475L1.16653 0L0 1.14343Z"
            fill="#1C1C1C"></path>
        </svg>
      </div>
    </div>

    <!-- An action belonging to the whole list — Refresh, an export — on the search row rather
         than the heading row above it. Pushed to the far end, so it reads as the counterpart to
         the field rather than as another filter. -->
    <div class="toolbar-action" *ngIf="hasToolbarAction">
      <ng-content select="[toolbarAction]"></ng-content>
    </div>

    <div class="flex-container">
      <!-- Multiple Filters Section -->
      <div class="multiple-filters-section"
        *ngIf="config.enableMultipleFilters && config.filterGroups && config.filterGroups.length > 0">
        <div class="filter-chips-container">
          <div *ngFor="let filterGroup of config.filterGroups" class="filter-chip-wrapper">
            <button class="filter-chip-btn" [class.active]="openFilterDropdowns[filterGroup.key]"
              [class.has-selection]="selectedFilters[filterGroup.key] !== 'all'"
              (click)="toggleMultipleFilterDropdown(filterGroup.key)">
              <span class="filter-chip-label">{{ filterGroup.label }}:</span>
              <span class="filter-chip-value" [style.color]="getSelectedFilterColorByKey(filterGroup.key)">
                {{ getSelectedFilterLabelByKey(filterGroup.key) }}
              </span>
              <i class="fa fa-chevron-down filter-chip-arrow"
                [class.rotated]="openFilterDropdowns[filterGroup.key]"></i>
            </button>

            <div class="filter-chip-dropdown" [class.show]="openFilterDropdowns[filterGroup.key]">
              <div *ngFor="let option of filterGroup.options" class="filter-chip-option"
                [class.selected]="selectedFilters[filterGroup.key] === option.value"
                (click)="selectMultipleFilter(filterGroup.key, option.value)">
                <span class="filter-option-indicator" [style.background-color]="option.color || '#666'"
                  *ngIf="option.value !== 'all'"></span>
                {{ option.label }}
                <i class="fa fa-check selected-icon" *ngIf="selectedFilters[filterGroup.key] === option.value"></i>
              </div>
            </div>
          </div>

          <!-- Clear All Filters Button -->
          <button *ngIf="getActiveFiltersCount() > 0" class="clear-all-filters-btn" (click)="clearAllFilters()"
            title="Clear all filters">
            <i class="fa fa-times"></i>
            Clear ({{ getActiveFiltersCount() }})
          </button>
        </div>
      </div>

      <!-- Single Filter Section (Legacy) -->
      <div class="filter-section"
        *ngIf="!config.enableMultipleFilters && config.showFilter
        && config.filterOptions.length > 0 && showsCollapsibleSections">
        <div class="filter-dropdown-wrapper">
          <button class="filter-toggle-btn" [class.active]="isFilterDropdownOpen" (click)="toggleFilterDropdown()">
            <i class="fa fa-filter filter-icon"></i>
            <span class="filter-label" [style.color]="getSelectedFilterColor()">
              {{ getSelectedFilterLabel() }}
            </span>
            <i class="fa fa-chevron-down dropdown-arrow" [class.rotated]="isFilterDropdownOpen"></i>
          </button>

          <div class="filter-dropdown-menu" [class.show]="isFilterDropdownOpen">
            <div *ngFor="let option of config.filterOptions" class="filter-dropdown-option"
              [class.selected]="selectedFilter === option.value" (click)="selectFilter(option.value)">
              <span class="filter-option-indicator" [style.background-color]="option.color || '#666'"
                *ngIf="option.value !== 'all'"></span>
              {{ option.label }}
              <i class="fa fa-check selected-icon" *ngIf="selectedFilter === option.value"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- Results Info -->
      <div class="results-info"
        *ngIf="config.showResultsCount !== false && showsCollapsibleSections">
        <span class="results-count">
          {{ filteredCount || 0 }} of {{ totalCount || 0 }} {{ config.resultLabel }}
          <span *ngIf="isFiltered()" class="filter-indicator">
            (filtered)
          </span>
        </span>
      </div>

      <!-- Custom content slot -->
      <div class="custom-actions">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>

<!-- Backdrop to close dropdowns when clicking outside -->
<div class="filter-backdrop" *ngIf="hasOpenDropdowns()" (click)="closeAllDropdowns()"></div>